import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation7 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };

    return (

        <>
        



        <div className="container mt-1 p-3 mb-1" >



            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}
                    >
                       Certificate Course in IT Security Support

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>

            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%" }}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in IT Security Support
                </h5>
                <p>
                    Almost everyone around us type at the keyboard of computers or tablets and use their smart phones daily. Computing and communications technologies have become an integral part of our life and in the context of this technology-rich environment the term “cyber space” often arises. </p>
                <p>Security Support course is designed for young aspirants who want to shape their careers in IT Security field.</p>

            </div>
            <hr />


            <h5 style={{ position: "relative" }}>

                Introduction
            </h5>
            <p>This course serves as an introduction to the exciting field of security in Information technology.</p>
            <p>As our daily lives become more and more dependent on Internet-based tools and services, and as those platforms accumulate our sensitive data, the demand grows for experts in the field of security over the internet.</p>
            <hr />
            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>

            <p>In this course, you will get an overview of the cyber security, various types of viruses and malware, how to protect our system from viruses, types of cyber-attacks, various tools used for cyber-attacks, how to secure system from cyber-attacks.</p>
            <p>After completing this course, you will get various Career Opportunities like:</p>

            <ul>
                <li> Security Consultant.</li>
                <li>Information Security Analyst.</li>
                <li>Ethical Hackers.</li>
                <li>Computer Forensics Analysts.</li>
                <li>Chief Information Security Officer.</li>
                <li>Penetration Tester.</li>
                <li>IT Security Consultant.</li>
                <li>Security Systems Administrator and so on…..</li>
            </ul>
            <hr />



            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> IT Security Support course is jointly certified by CDOE GJUST and HKCL.</li>
                </ul>
                <hr />
            </div>
            
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                    
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                </p>
            </div>
            <hr />

            <h5>Syllabus</h5>

            <div className='p-4' >

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Removing Viruses and Malwares</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li>Basics of Networking</li>
                                <li>Overview of Computer Viruses</li>
                                <li> Rootkits</li>
                                <li> Botnets</li>
                                <li>Ransomware</li>
                                <li>Using Antivirus Software</li>
                                <li>Adwares and Spywares</li>
                                <li>Antispam Technologies</li>
                                <li>Installing Free Antivirus and Scanning the PC</li>
                                <li>Installing Free Antispyware and scanning PC for Adware and Spywares</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">Securing Operating System and LAN </AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li> Securing Personal computers and Operating Systems</li>
                                <li>Patch Management</li>
                                <li>Patch Deployment and verification</li>
                                <li>Installing and configuring Open Source Firewall</li>
                                <li> Firewalls</li>
                                <li>Proxy server</li>
                                <li>Routers</li>
                                <li>Configuring Windows Firewall</li>
                                <li>Overview of IPS and IDS</li>
                                <li>Network load balancers</li>
                                <li>Securing Servers - Server Hardening</li>
                                <li>Windows Server Hardening</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Securing Wi-Fi Network</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li> WEP, WPA and WPA2</li>
                                <li>MAC Address Filtering</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Network Access Security</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li>Authentication and Encryption</li>
                                <li>Network Address Translation</li>
                                <li>Secure Remote Access</li>
                                <li>Secure Remote Access - Configuring VPN in Windows 7</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Cyber Attacks</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li>Common Cyber Attack</li>
                                <li>Phishing and Spoofing attacks</li>
                                <li> Social Engineering</li>
                                <li> Man in the Middle Attack</li>
                                <li> Denial of Service Attack</li>
                                <li> Using network packet capturing tool</li>
                                <li> Ethical Hacking</li>
                                <li>Foot printing</li>
                                <li>Open Source Security Scanning tools like NMAP</li>
                                <li>Using Kali Linux for exploring various Ethical Hacking Tools</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


            </div >
            <hr />


            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    </>
    );
}
export default CertificateInformation7;